export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7394.b3b468c1.jpg";